module.exports = __webpack_public_path__ + "static/media/silver3.0a66ae6f.jpg";